export default "__VITE_ASSET__B62djpR3__"